import { __extends } from "tslib";
import { UserBuilder } from '../../common/users/user-builder';
import { ArticleBuilder } from './article.builder';
import { randomTitle, RandomGenerator } from '../../../test-utils';
var ExtendedArticleBuilder = /** @class */ (function (_super) {
    __extends(ExtendedArticleBuilder, _super);
    function ExtendedArticleBuilder() {
        var _this = _super.call(this) || this;
        _this.article.draftTitle = 'Draft Title';
        _this.article.draftContent = 'Draft content';
        _this.article.hasUnpublishedChanges = false;
        _this.article.searchable = true;
        _this.article.listed = true;
        _this.article.phrases = [];
        _this.article.author = new UserBuilder().build();
        _this.article.lastUpdatedBy = new UserBuilder().build();
        _this.article.lastPublishDate = new Date().getDate();
        _this.article.brandId = '';
        return _this;
    }
    ExtendedArticleBuilder.prototype.build = function () {
        return this.article;
    };
    ExtendedArticleBuilder.prototype.withListed = function (listed) {
        this.article.listed = listed;
        return this;
    };
    ExtendedArticleBuilder.prototype.withSearchable = function (searchable) {
        this.article.searchable = searchable;
        return this;
    };
    ExtendedArticleBuilder.prototype.withPhrases = function (phrases) {
        this.article.phrases = phrases;
        return this;
    };
    ExtendedArticleBuilder.prototype.withDraftTitle = function (title) {
        this.article.draftTitle = title;
        return this;
    };
    ExtendedArticleBuilder.prototype.withDraftContent = function (content) {
        this.article.draftContent = content;
        return this;
    };
    ExtendedArticleBuilder.prototype.withLastOpenTask = function (task) {
        this.article.lastOpenTask = task;
        return this;
    };
    ExtendedArticleBuilder.prototype.withRecentTasks = function (tasks) {
        this.article.recentTasks = tasks;
        return this;
    };
    ExtendedArticleBuilder.prototype.withOpenTasksCount = function (count) {
        this.article.openTasksCount = count;
        return this;
    };
    ExtendedArticleBuilder.prototype.withAuthor = function (author) {
        this.article.author = author;
        return this;
    };
    ExtendedArticleBuilder.prototype.withLastUpdatedBy = function (lastUpdatedBy) {
        this.article.lastUpdatedBy = lastUpdatedBy;
        return this;
    };
    ExtendedArticleBuilder.prototype.withHasUnpublishedChanges = function (val) {
        this.article.hasUnpublishedChanges = val;
        return this;
    };
    ExtendedArticleBuilder.prototype.withLastPublishDate = function (lastPublishDate) {
        this.article.lastPublishDate = lastPublishDate;
        return this;
    };
    ExtendedArticleBuilder.prototype.withBrandId = function (id) {
        this.article.brandId = id;
        return this;
    };
    ExtendedArticleBuilder.generateRandomList = function (num) {
        return randomTitle(num)
            .map(function (title) { return new ExtendedArticleBuilder()
            .withTitle(title)
            .withId(RandomGenerator.id())
            .build(); });
    };
    return ExtendedArticleBuilder;
}(ArticleBuilder));
export { ExtendedArticleBuilder };
//# sourceMappingURL=extended-article.builder.js.map